import React, { useEffect, useState } from "react";
import { Input, InputWrap, Textarea } from "../atoms/Input";
import { Radio, RadioWrap } from "../atoms/Radio";
import { Select, SelectList, SelectOption } from "../atoms/Select";
import Button from "../atoms/Button";
import styled from "styled-components";
import Modal from "./Modal";
import ListTable from "../molecules/ListTable";
import { useGroupList } from "../../api/admin/group/hooks";

//TODO 리뷰 생성시 '리뷰 가져오기' 기능 구현 필요
//TODO 그룹 선택시 한 번에 리뷰이 - 리뷰어 세팅 되도록록
/**
 * 리뷰 생성 폼
 * - 관리자용 화면
 */
const ReviewAdminForm = ({ children, ...props }) => {
    let { stateValue, userListData } = props;
    const [activeRevieweesList, setActiveRevieweesList] = useState([]);
    const [tmpQuestionIdx, setTmpQuestionIdx] = useState(0);

    useEffect(() => {
        setActiveRevieweesList(stateValue[0]?.reviewees?.map((el) => el.idx) || []);
    }, [stateValue]);

    /* 그룹 배정 관련 */
    const { data: groupListData, isLoading: isGroupListLoading, refetch: groupListRefetch } = useGroupList()
    const groupList = groupListData?.data?.group || []
    // 어떤 리뷰이 행에 그룹 멤버를 배정할지 지정
    const [targetRevieweeRowIdx, setTargetRevieweeRowIdx] = useState(null)

    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        console.log("@@ReviewAdminForm - groupList", groupList)
    }, [groupList])

    const addQuestion = () => {
        let tmp = { ...stateValue[0] };
        tmp.questions.push({
            keyIdx: Math.floor(Math.random() * 1000 * -1),
            title: "",
            description: "",
            type: "0",
            is_comment_enabled: "1",
            is_subjective_answer_required: "1",
            options: [
                {
                    keyIdx: Math.floor(Math.random() * 10000 * -1),
                    text: "그렇다",
                    point: "100",
                },
                {
                    keyIdx: Math.floor(Math.random() * 10000 * -1),
                    text: "그런편이다",
                    point: "75",
                },
                {
                    keyIdx: Math.floor(Math.random() * 10000 * -1),
                    text: "아닌편이다",
                    point: "50",
                },
                {
                    keyIdx: Math.floor(Math.random() * 10000 * -1),
                    text: "아니다",
                    point: "25",
                },
                {
                    keyIdx: Math.floor(Math.random() * 10000 * -1),
                    text: "잘 모르겠다",
                    point: "0",
                },
            ],
        });
        stateValue[1](tmp);
    };

    const addReviewee = () => {
        let tmp = { ...stateValue[0] };
        tmp.reviewees.push({ idx: "-999", reviewers: [] });
        stateValue[1](tmp);
    };

    const revieweeSelectOnChangeHadler = (e, idx) => {
        let tmp = { ...stateValue[0] };
        tmp.reviewees[idx].idx = e.target.value;
        console.log(e.target.value);

        stateValue[1](tmp);
    };

    const reviewerOnChangeHandler = (e, idx, optionIdx) => {
        let tmp = { ...stateValue[0] };

        let flagNum = -1;
        tmp?.reviewees[idx]?.reviewers?.forEach((el, reviewersIdx) => {
            if (el.idx === optionIdx.toString()) {
                flagNum = reviewersIdx;
            }
        });

        if (flagNum > -1) {
            tmp.reviewees[idx].reviewers.splice(flagNum, 1);
        } else {
            console.log(tmp.reviewees[idx].reviewers);
            tmp.reviewees[idx].reviewers.push({ idx: optionIdx.toString() });
        }

        stateValue[1](tmp);
    };

    const revieweeDeleteHandler = (e, idx) => {
        let tmp = { ...stateValue[0] };
        tmp.reviewees.splice(idx, 1);
        stateValue[1](tmp);
    };

    const anonymityIsCheckedHandelr = (value) => {
        if (stateValue[0]["is_anonymity"] === value) {
            return true;
        } else {
            return false;
        }
    };

    const groupListModalOpenHandler = (el) => {
        setIsModalOpen(true);
    };

    const selectReviewersFromGroup = async (groupIdx) => {
        const users = groupList.find(g => g.idx === groupIdx)?.user || []

        // 현재 행의 리뷰이(idx)와 같은 유저는 제외
        const currentRevieweeIdx = stateValue[0].reviewees[targetRevieweeRowIdx].idx
        const filteredUsers = users.filter(u => u.idx !== currentRevieweeIdx)

        // 기존 리뷰어 목록에 그룹에서 가져온 필터링된 유저 목록{user:idx} 병합
        let tmp = { ...stateValue[0] }
        const originReviewers = tmp.reviewees[targetRevieweeRowIdx].reviewers || []
        const originIdxList = originReviewers.map(r => r.idx)
        filteredUsers.forEach(u => {
            if (!originIdxList.includes(u.idx)) {
                originReviewers.push({ idx: u.idx })
            }
        })
        tmp.reviewees[targetRevieweeRowIdx].reviewers = originReviewers

        // 갱신 후 모달 닫기
        stateValue[1](tmp)
        setIsModalOpen(false)
    }

    const groupListItemHoverHandler = (groupIdx) => {
        const users = groupList.find(g => g.idx === groupIdx)?.user || []
        //TODO 마우스 오버 위치에 그룹 멤버 목록 보여주도록
    };

    return (
        <>
        <Modal title="그룹 목록" desc="그룹을 선택하면 그룹 멤버가 리뷰어로 지정됩니다." isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}>
            <ListTable>
                <thead>
                    <tr>
                        <th style={{ width: "10%" }} className="center">번호</th>
                        <th style={{ width: "90%" }}>그룹명</th>
                    </tr>
                </thead>
                {groupList?.map((el, seq) => (
                    <tbody>
                        <tr className="hover-row">
                            <td className="seq">{seq + 1}</td>
                            <td>
                                <div onClick={() => {selectReviewersFromGroup(el.idx)}} onMouseOver={() => {groupListItemHoverHandler(el.idx)}}>
                                    {el.name}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                ))}
            </ListTable>
        </Modal>

        <Wrap col gap={"30px"}>
            <Wrap col gap={"20px"} className="form-card">
                <h4>리뷰 정보</h4>
                <Wrap col gap={"10px"}>
                    <InputWrap title={"리뷰 제목"}>
                        <Input name={"title"} value={stateValue[0].title} stateValue={stateValue} placeholder={`리뷰 제목`} />
                    </InputWrap>
                    <InputWrap title={"리뷰 설명"}>
                        <Textarea name={"description"} value={stateValue[0].description} stateValue={stateValue} placeholder={`리뷰 설명 (선택)`} />
                    </InputWrap>
                </Wrap>
                <Wrap col gap={"15px"}>
                    <InputWrap title={"익명 여부"}>
                        <RadioWrap name={"is_anonymity"} stateValue={stateValue}>
                            <Radio value="1" >익명</Radio>
                            <Radio value="0" >기명</Radio>
                        </RadioWrap>
                    </InputWrap>

                    <InputWrap title={"리뷰이 직접 선택"}>
                        <RadioWrap name={"is_reviewee_selectable"} stateValue={stateValue}>
                            <Radio value="1">가능</Radio>
                            <Radio value="0">불가</Radio>
                        </RadioWrap>
                    </InputWrap>

                    <InputWrap title={"완료된 리뷰 공개"}>
                        <RadioWrap name={"is_public"} stateValue={stateValue}>
                            <Radio value="1">공개</Radio>
                            <Radio value="0">숨김</Radio>
                        </RadioWrap>
                    </InputWrap>
                </Wrap>
            </Wrap>

            {/* 리뷰이 지정 */}
            <Wrap col gap={"20px"} className="form-card">
                <h4>리뷰이 지정</h4>

                {stateValue[0]?.reviewees &&
                    stateValue[0].reviewees.map((el, idx) => {
                        return (
                            <Wrap row gap={"10px"} key={idx}>
                                <Select value={el.idx} name={`reviewee_${idx}`} style={{ width: "300px" }} onChange={(e) => revieweeSelectOnChangeHadler(e, idx)}>
                                    <SelectOption value={-999} selected={el.idx?.toString() === -999 ? true : false}>
                                        선택
                                    </SelectOption>
                                    {userListData &&
                                        userListData.map((reviewee, revieweeIdx) => {
                                            if (el.idx?.toString() === reviewee.idx?.toString() || !activeRevieweesList.includes(reviewee.idx)) {
                                                return (
                                                    <SelectOption key={reviewee.idx} value={reviewee.idx} selected={el.idx?.toString() === reviewee.idx?.toString() ? true : false}>
                                                        {reviewee.name} ({reviewee.name_ko})
                                                    </SelectOption>
                                                );
                                            }
                                        })}
                                </Select>

                                <SelectList 
                                    idx={idx} 
                                    type="user" 
                                    // 현재 행에서 리뷰이로 선택한 아이템은 제외
                                    data={userListData.filter(u => u.idx !== el.idx)}
                                    onChange={reviewerOnChangeHandler} 
                                    stateValue={stateValue} 
                                    preSelectedActiveList={el.reviewers.map(r => r.idx)}
                                    />

                                <Button type="dark" onClick={(e) => {groupListModalOpenHandler(e, idx); setTargetRevieweeRowIdx(idx)}} style={{ minWidth: "60px" }}>
                                    그룹
                                </Button>

                                <Button type="sub" onClick={(e) => revieweeDeleteHandler(e, idx)} style={{ minWidth: "60px" }}>
                                    삭제
                                </Button>
                            </Wrap>
                        );
                    })}

                <Button type="main" onClick={(e) => addReviewee(e)}>
                    리뷰이 추가
                </Button>
            </Wrap>

            <Wrap col gap={"20px"} className="form-card">
                <h4>질문/답변</h4>

                {stateValue[0].questions &&
                    stateValue[0].questions.map((el, idx) => {
                        return <ReviewQuestion key={el.idx ?? el.keyIdx} reviewData={stateValue[0]} el={el} idx={idx} stateValue={stateValue} />;
                    })}

                <Button type={"main"} onClick={(e) => addQuestion(e)}>
                    질문 추가
                </Button>
            </Wrap>
        </Wrap>
        </>
    );
};

const ReviewQuestion = ({ children, ...props }) => {
    let { reviewData, el, idx, stateValue } = props;

    const questionOnChangeHandler = (e) => {
        let splitName = "";

        if (e && e.target) {
            splitName = e.target.name.split("-");
        }

        if (splitName) {
            let tmp = { ...stateValue[0] };
            tmp["questions"][parseInt(splitName[1])] = {
                ...tmp["questions"][parseInt(splitName[1])],
                [splitName[2]]: e.target.value,
            };
            stateValue[1](tmp);
        }
    };

    const questionTypeCheckedHandler = (value) => {
        if (stateValue[0]["questions"][idx]["type"] === value) {
            return true;
        } else {
            return false;
        }
    };

    const isCommentEnabledCheckedHandler = (value) => {
        if (stateValue[0]["questions"][idx]["is_comment_enabled"] === value) {
            return true;
        } else {
            return false;
        }
    };

    const isSubjectiveAnswerRequiredCheckedHandler = (value) => {
        if (stateValue[0]["questions"][idx]["is_subjective_answer_required"] === value) {
            return true;
        } else {
            return false;
        }
    };

    const questionDeleteHandler = () => {
        let tmp = { ...stateValue[0] };
        tmp["questions"].splice(idx, 1);

        stateValue[1](tmp);
    };

    return (
        <>
            {/* 질문/답변 */}
            <Wrap col gap={"15px"} className="review-card">
                <Wrap col gap={"10px"}>
                    <Wrap row>
                        <h5 style={{ display: "flex", alignItems: "center", width: "100%", gap: "10px" }}>
                            {idx + 1}.
                            <Input name={`questions-${idx}-title`} stateValue={stateValue} placeholder={`질문`} value={el.title} onChange={(e) => questionOnChangeHandler(e)} />
                            <Button type="sub" onClick={questionDeleteHandler} style={{ minWidth: "60px" }}>
                                삭제
                            </Button>
                        </h5>
                    </Wrap>

                    <Input name={`questions-${idx}-description`} stateValue={stateValue} placeholder={`질문 설명 (선택)`} value={el.description} onChange={(e) => questionOnChangeHandler(e)} />

                    <Wrap row>
                        <RadioWrap name={`questions-${idx}-type`} stateValue={stateValue} onChange={questionOnChangeHandler}>
                            <Radio value="0" isChecked={questionTypeCheckedHandler("0")}>
                                객관식
                            </Radio>
                            <Radio value="1" isChecked={questionTypeCheckedHandler("1")}>
                                주관식
                            </Radio>
                        </RadioWrap>

                        {stateValue[0].questions[idx].type === "0" && (
                            <RadioWrap name={`questions-${idx}-is_comment_enabled`} stateValue={stateValue} onChange={questionOnChangeHandler} align="right">
                                <Radio value="1" isChecked={isCommentEnabledCheckedHandler("1")}>
                                    코멘트 사용
                                </Radio>
                                <Radio value="0" isChecked={isCommentEnabledCheckedHandler("0")}>
                                    코멘트 숨김
                                </Radio>
                            </RadioWrap>
                        )}

                        {stateValue[0].questions[idx].type === "1" && (
                            <RadioWrap name={`questions-${idx}-is_subjective_answer_required`} stateValue={stateValue} onChange={questionOnChangeHandler} align="right">
                                <Radio value="1" isChecked={isSubjectiveAnswerRequiredCheckedHandler("1")}>
                                    답변 필수
                                </Radio>
                                <Radio value="0" isChecked={isSubjectiveAnswerRequiredCheckedHandler("0")}>
                                    답변 옵션
                                </Radio>
                            </RadioWrap>
                        )}
                    </Wrap>

                    <Wrap col gap={"10px"}>
                        <ReviewAnswer reviewData={reviewData} idx={idx} stateValue={stateValue} />
                    </Wrap>
                </Wrap>
            </Wrap>
        </>
    );
};

const ReviewAnswer = ({ children, ...props }) => {
    let { reviewData, idx, stateValue } = props;

    const addOption = () => {
        let tmp = { ...reviewData };
        tmp.questions[idx].options.push({ keyIdx: Math.floor(Math.random() * 10000 * -1), text: "", point: "0" });
        stateValue[1](tmp);
    };

    const answerOnChangeHandler = (e) => {
        let splitName = e.target.name.split("_");
        let tmp = { ...stateValue[0] };

        if (!tmp["questions"][parseInt(splitName[1])]["options"][parseInt(splitName[2])]) {
            tmp["questions"][parseInt(splitName[1])]["options"][parseInt(splitName[2])] = {};
        }

        tmp["questions"][parseInt(splitName[1])]["options"][parseInt(splitName[2])] = {
            ...tmp["questions"][parseInt(splitName[1])]["options"][parseInt(splitName[2])],
            [splitName[3]]: e.target.value,
        };
        stateValue[1](tmp);
    };

    const optionScoreOnChangeHandler = e => {
        if (e.target.value === "") {
            e.target.value = "0"
        }
    };

    const optionDeleteHandler = (e, optionIdx) => {
        let tmp = { ...stateValue[0] };
        tmp["questions"][parseInt(idx)]["options"].splice(optionIdx, 1);
        stateValue[1](tmp);
    };

    return (
        <>
            {/* 옵션 문항 */}
            {reviewData.questions && reviewData.questions[idx].type === "0" && (
                <>
                    {reviewData.questions[idx].options.map((optionEl, optionIdx) => {
                        return (
                            <Wrap key={optionEl.keyIdx} row gap={"10px"}>
                                <span style={{ display: "inline-flex", alignItems: "center", width: "10px" }}>{optionIdx + 1}. </span>
                                <Input name={`question_${idx}_${optionIdx}_text`} stateValue={stateValue} placeholder={`객관식 옵션 문항`} ect={"answer_option"} onChange={(e) => answerOnChangeHandler(e)} value={optionEl.text} />
                                <Input type="number" name={`question_${idx}_${optionIdx}_point`} stateValue={stateValue} placeholder={`문항 점수`} onChange={(e) => { answerOnChangeHandler(e); optionScoreOnChangeHandler(e) }} value={optionEl.point} style={{ width: "100px" }} />
                                <Button type="sub" onClick={(e) => optionDeleteHandler(e, optionIdx)} style={{ minWidth: "60px" }}>
                                    삭제
                                </Button>
                            </Wrap>
                        );
                    })}

                    <Button type={"main"} onClick={addOption} style={{ width: "88px", marginLeft: "20px", alignSelf: "flex-start" }}>
                        옵션 추가
                    </Button>
                </>
            )}
        </>
    );
};

const Wrap = styled.div`
    display: flex;
    width: 100%;

    label:not(:has(input[type="radio"])) {
        width: 200px;
    }

    input,
    textarea {
        padding: 10px;
        width: 100%;
    }

    ${(props) => props.col && `flex-direction: column;`}
    ${(props) => props.row && `flex-direction: row;`}
    ${(props) => props.gap && `gap: ${props.gap}`}
`;

export default ReviewAdminForm;